// Maps the Salesforce PlanOrderFormService JSON shape BACK into the
// React app's planOrder slice. Inverse of toPlanOrder.js — used when the
// app loads with a ?caseId= URL param and hydrates from an existing record.

import { splitRetirement } from './planRetirement.js';

const str = v => (v === undefined || v === null ? '' : String(v));
const yesNo = v => v === 'Yes' || v === true;

export function fromPlanOrder(sf = {}) {
  // "Age 65" goes back into the age box; a date stays a date.
  const clientRet = splitRetirement(sf.clientRetirementDate);
  const spouseRet = splitRetirement(sf.spouseRetirementDate);
  return {
    _caseId: str(sf.caseId),
    planOrder: {
      // Documents
      investmentStatementOnFile: yesNo(sf.investmentStatementsOnFile),
      taxReturnOnFile: yesNo(sf.taxReturnOnFile),
      documentsEmailDate: str(sf.dateEmailRequestForDocumentsSent),
      planningLifeRequested: yesNo(sf.planningLiteRequested),

      // Base facts
      clientRetirementDate: clientRet.date,
      clientRetirementAge: clientRet.age,
      spouseRetirementDate: spouseRet.date,
      spouseRetirementAge: spouseRet.age,
      eMoneyRorPre: str(sf.eMoneyRoRPreRetirement),
      eMoneyRorPost: str(sf.eMoneyRoRPostRetirement),
      baseFactsNotes: str(sf.notesBaseFacts),

      // Observations
      currentCashFlow: str(sf.currentCashFlow),
      maxingEmployerPlan: str(sf.maxingEmployerRetirementPlan),
      excessCashGoing: str(sf.whereIsExcessCashGoing),
      whereAreTheyPullingMoneyFrom: str(sf.whereAreTheyPullingMoneyFrom),
      extraCashReserves: str(sf.howMuchExtraCashReserves),
      onTrackToRetire: str(sf.areTheyOnTrackToRetire),
      observationNotes: str(sf.observationsNotes),

      // Taxes
      taxBracket: str(sf.whatTaxBracketAreTheyInNow),
      filingStatus: str(sf.fillingStatusThisYear),
      taxesBeforeRMDs: str(sf.taxBracketInRetirementComparedTo),
      taxesAfterRMDs: str(sf.taxBracketWhenRMDsStartComparedTo),
      unrealizedCapGains: str(sf.unrealizedCapGains),
      taxReturnDifferences: str(sf.differencesFromPriorTaxReturn),
      charitablyInclined: str(sf.charitabilityInclined),
      highLevelStrategies: str(sf.highLevelStrategiesForThisYear),

      // Strategies — Cash Flow & Retirement
      cashReservesStrategy: str(sf.cashReservesStrategy),
      ssClaimingStrategy: str(sf.ssClaimingStrategy),
      otherCashFlowStrategies: str(sf.otherFixedIncome),

      // Strategies — Taxes
      rothConversionStrategy: str(sf.rothConversionStrategy),
      charitableStrategies: str(sf.charitableStrategies),
      rothIraContributions: str(sf.iraRothIra),
      capitalGains: str(sf.capitalGains),
      capitalGainsWorksheet: str(sf.capitalGainsWorksheetRequest),
      employerPlanContributions: str(sf.employerPlan),
      otherTaxStrategies: str(sf.otherTaxStrategies),

      // Strategies — Investment Planning
      pureIPS: str(sf.pureIPS),
      annuityStrategy: str(sf.annuityStrategy),
      outside401kRequest: str(sf.x401kAllocation || sf.x401kIPS),
      morningstarEntered: str(sf.morningstarEntered),
      otherInvestRequests: str(sf.otherInvestmentRequests),

      // Strategies — Insurance & Risk
      lifeInsurance: str(sf.lifeInsurance),
      pAndC: str(sf.pAndC),
      ltcDisability: str(sf.ltcDisability),

      // Strategies — Estate Planning
      estatePlanStatus: str(sf.estatePlan),
      estatePlanningDetails: str(sf.estatePlanningDetails),
      estatePlanOptions: str(sf.estatePlanOptions)
        ? str(sf.estatePlanOptions).split(/[;,]/).map(x => x.trim()).filter(Boolean)
        : [],

      // Alternative Scenarios
      alternativeScenarios: str(sf.alternativeScenarios),
      alternativeScenarioDescription: str(sf.alternativeScenarioDescription),
    },
  };
}
